/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Routing_NoteInputs */



/**
* | output |
* | --- |
* | "Certificates are issued and renewed automatically once the records resolve. If they are later removed, the site stops working within about a week." |
*
* @param {Canvas_Domain_Routing_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_routing_note = /** @type {((inputs?: Canvas_Domain_Routing_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Routing_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zertifikate werden automatisch ausgestellt und erneuert, sobald die Einträge aufgelöst werden. Werden sie später entfernt, funktioniert die Seite innerhalb von etwa einer Woche nicht mehr.")
	return /** @type {LocalizedString} */ ("Certificates are issued and renewed automatically once the records resolve. If they are later removed, the site stops working within about a week.")
});